<template>
  <CommonPopup
    ref="refCommonPopup"
    :show-close-btn="true"
  >
    <div class="rule-popup">
      <div class="rule-popup-title">虾米车服充电券服务协议</div>
      <div class="rule-popup-info">
        1．特别提示
        <br>1.1 本《虾米车服充电券服务协议》（以下简称"本协议"是您（以下简称“您”或“用户”）与中保车服科技服务股份有限公司（以下简称"我们”或“本公司”）之间关于您使用"小桔充电”信息平台（以下简称"平台"以及您通过平台获得相关信息服务（以下简称＂本服务”或“平台服务”）所订立的协议。
        <br>1.2 您在使用平台各项服务（以下简称“服务”）之前，请您认真阅读本协议，特别是涉及免除或者限制平台责任的条款、限制您权利的条款、争议解决方式、司法管辖、法律适用的条款。免除或者限制责任的条款将以粗体标识，请您重点阅读。
        <br>1.3 平台如根据法律法规的变化及/或维护交易秩序、用户权益保障需要，对本协议内容进行修改，将以提前公示推送通知或弹窗等方式通知到您。您可以随时在平台查阅修改后的最新版本协议。如您对已生效的变更事项不同意的，您应当于变更事项确定的生效之日起停止使用本平台服务，变更事项对您不产生效力。本协议变更事项生效后，如果您继续使用本平台服务，我们可以理解您已接受修改后的协议和已生效的变更事项。
        <br>2．用户资格
        <br>2.1 您作为平台用户应当具备与您行为相适应的民事行为能力。若您是未满18周岁的未成年人，应在监护人陪同下阅读本协议并在征得监护人同意后在平台注册。
        <br>2.2 如您不符合用户资格要求，还请停止注册或使用平台服务。如您注册账号后因情况变化，不再符合有关用户资格的要求，还请您停止使用平台服务，并注销账号。
        <br>2.3 如您不符合平台用户资格要求，仍使用平台服务，且非平台原因给他人造成损失，您或您的监护人需承担相应法律责任。
        <br>3．账号注册
        <br>3.1 使用平台服务前，您需要在平台进行注册，同意授权即为注册成功，如注册成功，您将获得平台账号。用户确认，使用用户微信手机号授权登录后在平台的一切行为均代表用户本人。用户账号操作所产生的电子信息记录均为用户行为的有效凭据，并由用户本人承担由此产生的法律责任。
        <br>3.2 由于用户账号关联用户个人信息等，仅当有法律明文规定、司法裁定或经平台同意，并符合平台规则规定的账号转让流程的情况下，用户可进行账号转让。用户账号一经转让，该账号项下权利义务一并转移。除此以外，用户不得将账号转让、售卖、赠与、借用、租用给第三方或以其他方式许可第三方使用。如用户因违反本条约定或账号遭受攻击、诈骗等而遭受损失，用户应通过司法、行政等救济途径向侵权行为人追偿。如用户因违反本条约定给他人造成损失，用户应就全部损失与实际使用人承担连带责任，且平台有权追究用户违约责任。
        <br>3.3 用户如发现账号存在安全漏洞或其他异常情况，应立即以有效方式通知平台，要求平台暂停相关服务，并根据平台的要求，协助平台向公安机关报案。
        <br>3.4 用户向平台发出的通知至少应当包括情况描述、相关的初步证据、要求平台采取的处理措施、通知人联系方式等，缺乏前述信息的通知视为无效通知。用户理解平台对用户的通知请求识别、采取行动需要合理时间，平台对非因平台过错产生的后果不承担除法律法规明确规定之外的责任。
        <br>3.5 用户注册账号后如果长期不登录该账号，平台可以收回、注销该账号或设定账号功能限制，以免造成资源浪费，由此带来的损失由用户自行承担。
        <br>4．服务使用
        <br>4.1 本平台提供充电券的购买服务，平台根据您购买的充电券类型，向您提供充电设施运营服务商（以下简称"服务提供方”）的相关信息按钮供您点击跳转，以便促成您与服务提供方之间达成充电服务交易（以下简称"充电服务”）。本平台提供的信息服务，包括提供购买充电券的通道、展示充电券信息，提供跳转按钮至充电服务商，跳转至充电服务商之后的任何信息服务均与本平台无关。【特澄清如下】本平台是协助您与服务提供方平台之间达成充电服务交易的网络信息技术平台，并非直接提供充电服务，而是为您和服务提供方之间提供信息及技术服务。除法律法规有明确规定或平台存在过错外，本平台不对充电服务过程中您与服务提供商之间产生的纠纷或争议承担责任，您和服务提供方应自行解决相关事宜，本平台将在平台公示的服务范围内提供必要协助。
        <br>4.2 您可以免费下载和使用平台的应用程序和服务。我们保留日后就服务向您收费的权利。如果我们决定就服务收取费用，我们将提前向您发送通知，确保您享有充分选择的权利。
        <br>4.3 平台可能会与第三方合作并由第三方向您提供相关的服务或权益（包括但不限于支付服务、寻址定位服务、广告服务、优惠权益等）。
        <br>4.4 用券说明
        <br>充电券的可使用站点覆盖全国；
        <br>充电券属于虚拟产品，购买后不支持退款；
        <br>充电券的有效期都为1个月，过期后将自动作废；
        <br>小桔充电券使用门槛：无使用订单金额门槛，且一笔充电订单仅可用一张券；
        <br>特来电充电券使用门槛：仅特来电小程序标有“特来电权益”标签的场站可使用，无使用订单金额门槛，且一笔充电订单可叠加使用多张特来电充电券；
        <br>在【小桔充电】或【特来电】小程序进行充电订单支付时，将自动使用已购买的充电优惠券；
        <br>【小桔充电券】售价为面额的92折，【特来电充电券】售价为面额的99折；
        <br>充电券可抵扣电费及服务费；
        <br>购买充电券成功后，可在【我的充电券】页面查看，也可在【小桔充电】或【特来电】小程序中查看。
        <br>4.5 购买充电券
        <br>4.5.1 买方的义务：
        <br>购买并支付充电券的售价价款；
        <br>验收查看标的物（即查看购买对应数量的充电券）。
        <br>4.5.2
        卖方的义务：
        <br>根据买方购买的充电券数量以及面额，在平台中发放足量足额的充电券给到买方。
        <br>4.5.3 买方的权利：
        <br>受领充电券；
        <br>要求卖方按照购买支付约定给付充电券
        <br>4.5.4 卖方的权利：
        <br>取得相应的充电券款金额；
        <br>要求买方按约定检验充电券。
        <br>4.6 拉新返利
        <br>您可以在【个人中心】页面点击【分享海报】生成专有分享码海报并进行转发。虾米车服平台新用户扫描您的分享码后，将成为您的直接拉新人。您的直接拉新人通过他的分享码发展新用户，则该新用户将成为您的间接拉新人。
        <br>您的直接拉新人在虾米车服充电服务中购买充电券，您将获得订单金额0.7%的返利；您的间接拉新人购买充电券，您将获得订单金额0.3%的返利。
        <br>本活动的拉新权益只涵盖直接拉新人和间接拉新人，不穿透到第三层及以上转发。
        <br>5．保证与承诺您使用本服务的过程中，作出如下保证和承诺：
        <br>5.1 您向平台提供的全部信息真实、准确、完整、合法、有效。
        <br>5.2 您在使用平台服务的过程中实施的所有行为均遵守国家法律法规等的规定，不违背社会公共利益或公共道德，不侵犯或试图侵犯他人的合法权益。
        <br>5.3 您将严格遵守本协议、平台规则以及与服务提供方的要求。
        <br>5.4 您在平台上发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表）不包含以下信息。如您违反本条约定，平台有权暂停或终止您使用本平台服务，并删除相关内容。
        <br>5.4.1 违反国家法律法规禁止性规定的;
        <br>5.4.2 政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的;
        <br>5.4.3 欺诈、虚假、不准确或存在误导性的;
        <br>5.4.4 侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的;
        <br>5.4.5 侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的;
        <br>5.4.6 存在可能破坏、篡改、删除、影响平台系统正常运行或未经授权秘密获取平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的;
        <br>5.4.7 其他违背社会公共利益或公共道德或依据相关平台协议、规则的规定不适合在平台上发布的。
        <br>5.5 不以任何方式干扰或试图干扰平台的正常运作或任何形式侵害平台合法权益，包括但不限于使用任何装置、病毒、木马等干预平台的正常运作，采取任何将导致不合理的庞大数据负载加诸平台网络设备的行动等。在使用平台服务时，您的手机不得开启root权限。
        <br>5.6 不进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器账号；未经允许不进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，不企图探查、扫描、测试平台系统或网络的弱点或其它实施破坏网络安全的行为;不企图干涉、破坏系统等的正常运行。
        <br>5.7 尊重平台合法权利，不实施侮辱、诽谤、侵犯平台名誉权或其他侵犯平台合法权利的行为。
        <br>6．责任限制
        <br>6.1 平台可能为不同的终端设备开发了不同的应用程序版本，您应当根据实际情况选择下载合适的版本进行安装。平台不保证所有的版本与相关设备的适配性和可用性，亦不保证所有的版本提供的服务的一致性。
        <br>6.2 为了完善服务内容，平台将不断努力开发新的服务，并为您不时提供应用程序的更新（这些更新可能会采取应用程序替换、修改、功能强化、版本升级等形式）。应用程序新版本发布后，旧版本的应用程序可能无法使用，平台不保证旧版本应用程序可继续使用及相应服务，因此请您随时核对并下载最新版本的应用程序。
        <br>6.3平台作为信息技术平台，无法控制其他用户履约能力，无法对平台服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、稳定性、完整性和及时性作出任何承诺和保证，除因平台存在过错或法律法规明确规定外，您自行承担使用平台服务产生的依据法律规定应当由您承担的风险。
        <br>6.4 平台将会尽其商业上的合理努力保障您在平台及服务中的数据存储安全，您可根据自身需求自行备份平台及服务中的相关数据。
        <br>6.5 在使用本服务的过程中，可能会遇到不可抗力、技术风险等因素，使本服务发生中断，对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更、数据丢失等情形，平台在法律允许的范围内免责：
        <br>6.5.1 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素。
        <br>6.5.2 因电力供应故障、通讯网络故障（包括但不限于电子通讯传达失败或延时、用于电子通讯的计算机程序对电子通讯的拦截或操纵）等公共服务因素或您自身因素（包括但不限于您操作不当、通过非平台授权的方式使用本服务）或第三人因素（包括但不限于受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏、顾客的错误下单等错误操作）。
        <br>6.5.3 其他平台无法控制或合理预见的情形。
        <br>6.6 如果平台发现了因系统故障或其他原因导致的处理错误，平台都应该在根据本协议约定通知用户后纠正该错误、回转/回档相关交易或数据。
        <br>6.7 平台发生合并、分立、收购、资产转让时，平台可向第三方转让本服务下相关资产。平台在单方通知您并确保您的权利不受损的情况下，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以平台通知的为准。
        <br>6.8 平台对因平台原因给您造成的损失依法承担相应的赔偿责任。
        <br>7．知识产权
        <br>7.1 本公司及/或本公司关联公司是本平台的知识产权权利人。本平台的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本平台相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档）均受中华人民共和国法律法规和相应的国际条约保护，本公司及/或本公司关联公司享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
        <br>8．广告及第三方链接
        <br>8.1 您同意平台可以在提供服务的过程中自行或由第三方广告商向您发送广告、推广或宣传信息（包括商业与非商业信息）。
        <br>8.2 在您使用平台期间，平台可能会不时地提供由第三方拥有并控制的网站链接，以便您跟第三方沟通，向其购买产品或服务，参加其提供的促销活动。该等链接会带领您离开平台并且该等链接所指向的第三方网站内容不在平台控制范围之内，这些第三方网站各自订立了条款、条件和隐私政策。因此，您应充分阅读并理解该等网站的内容及活动并承担浏览或访问这些网站的风险。
        <br>9．违约责任
        <br>9.1 如用户违反本协议或平台规则的约定，平台视您行为严重程度采取警告、暂停服务、终止服务、注销账号等措施。
        <br>10．通知与送达
        <br>10.1 您提供给平台的联系方式（包括您的电子邮件地址联系电话、联系地址等）应保持有效和可联系畅通，如联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态，否则平台存储的您最后一次提供的联系方式即视为您的有效联系方式；您的平台账号如可正常接受平台推送信息、系统消息的也视为有效联系方式；因您未及时更新联系方式而导致无法及时获取查看相关通知的，由您自行承担相应后果。
        <br>10.2 平台将向您的上述有效联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
        <br>10.3 通知如果是通过专人递送、邮资预付挂号信或商业快递服务发出的，则应视为在快递、信件送至您提供的联系地址于签收日或拒收之日有效送达。
        <br>10.4 通知如果是通过电子邮件发出的，则应自电子邮件进入您提供的电子邮箱的时间或您提供的电子邮箱地址失效时平台授权电子邮箱收到传送失败的系统提示时即视为有效送达。
        <br>10.5 通知如果是以除电子邮件以外的其他电子形式发出的，包括但不限于在平台公告、公示，向您提供的联系电话发送手机短信，向您的账号发送弹窗信息、系统消息等，在平台使用的发送设备上显示发送成功后即视为送达。
        <br>11．法律适用与管辖
        <br>11.1 本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律。如法律无相关规定的，参照商业惯例及/或行业惯例。
        <br>11.2 您因使用平台服务所产生及与平台服务有关的争议，由平台与您协商解决。协商不成时，任何一方均可向中保车服科技服务股份有限公司所在地有管辖权的人民法院提起诉讼，届时法院可按照您在平台留存的联系信息向您进行电子送达。
        如有任何疑问，请联系客服，客服电话：4000026862转6。
      </div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';

export default {
  name: 'ServiceProtocolPopup',
  components: {
    CommonPopup
  },
  data() {
    return {};
  },
  methods: {
    openPopup() {
      this.$refs.refCommonPopup.openPopup();
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.rule-popup {
  box-sizing: border-box;
  padding: 32px;
  max-height: 1200px;
  background: #ffffff;
  border-radius: 20px;
  width: 600px;
  overflow: auto;

  .rule-popup-title {
    font-size: 32px;
    color: #383838;
    font-weight: bold;
    text-align: center;
    margin-bottom: 48px;
  }
  .rule-popup-info {
    font-size: 28px;
    color: #383838;
    font-weight: 400;
    line-height: 2;
  }
}
</style>
